import { Profile } from 'oidc-client';
import { AuthContextProps } from 'oidc-react';

export const GetAccountSettings = (auth: AuthContextProps) => {
    return {
        token: auth.userData?.access_token ?? '',
        profile: auth.userData?.profile as Profile
    };
};